import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { BackOfficeProvider } from '../../Models/Models/BackOfficeIntegration/BackOfficeProvider';

declare var IS_RUNNING_IN_APP_POOL;

export class BackOfficeProvidersClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(): Promise<Array<BackOfficeProvider>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/BackOfficeIntegration/BackOfficeProviders/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = {}

    return AjaxWrapper.get<Array<BackOfficeProvider>, any>(url, data);
  }
}

